export default import.meta.ROLLUP_FILE_URL_k_HDfjc1pIgQXRfoWAQvLA